// AUTO-GENERATED by `npm run codegen:docs` (scripts/gen-docs-tree.ts).
// Do not edit by hand — update the MDX frontmatter or `_meta.yaml` files
// under `content/` and re-run the generator.
import type { DocNode } from './docs-tree-utils';

export const DOCS_TREE: DocNode[] = [
  {
    slug: 'example',
    title: 'Example',
    collapsed: true,
    children: [
      {
        slug: 'example',
        title: 'Example',
        roles: ['chat-access'],
        contentPath: './content/example/example.mdx',
        headings: [
          { id: 'features', text: 'Features', level: 2 },
          { id: 'invoke-a-skill', text: 'Invoke a skill', level: 3 },
          { id: 'how-to-use', text: 'How to use', level: 2 },
          { id: 'troubleshooting', text: 'Troubleshooting', level: 2 },
          { id: 'permissions', text: 'Permissions', level: 2 },
        ],
      },
    ],
  },
  {
    slug: 'data',
    title: 'Data',
    collapsed: true,
    children: [
      {
        slug: 'data-foundry',
        title: 'Data Foundry',
        contentPath: './content/data/data-foundry/index.mdx',
        children: [
          {
            slug: 'sources',
            title: 'Connect a source',
            contentPath: './content/data/data-foundry/sources.mdx',
            headings: [
              { id: 'two-kinds-of-sources', text: 'Two kinds of sources', level: 2 },
              { id: 'prerequisites', text: 'Prerequisites', level: 2 },
              { id: 'add-a-source', text: 'Add a source', level: 2 },
              { id: 'manage-your-sources', text: 'Manage your sources', level: 2 },
              { id: 'deleting-a-source', text: 'Deleting a source', level: 3 },
              { id: 'common-tasks', text: 'Common tasks', level: 2 },
              { id: 'troubleshooting', text: 'Troubleshooting', level: 2 },
              { id: 'permissions', text: 'Permissions', level: 2 },
              { id: 'related-topics', text: 'Related topics', level: 2 },
            ],
          },
          {
            slug: 'data-checks',
            title: 'Create a data check from SQL',
            contentPath: './content/data/data-foundry/data-checks.mdx',
            headings: [
              { id: 'create-a-data-check', text: 'Create a data check', level: 2 },
              { id: 'data-checks-on-live-connections', text: 'Data checks on live connections', level: 2 },
              { id: 'common-tasks', text: 'Common tasks', level: 2 },
              { id: 'troubleshooting', text: 'Troubleshooting', level: 2 },
              { id: 'permissions', text: 'Permissions', level: 2 },
              { id: 'related-topics', text: 'Related topics', level: 2 },
            ],
          },
          {
            slug: 'assistant',
            title: 'Data Foundry assistant',
            contentPath: './content/data/data-foundry/assistant.mdx',
            headings: [
              { id: 'what-it-sees', text: 'What it sees', level: 2 },
              { id: 'what-it-can-do', text: 'What it can do', level: 2 },
              { id: 'try-it', text: 'Try it', level: 2 },
              { id: 'common-tasks', text: 'Common tasks', level: 2 },
              { id: 'permissions', text: 'Permissions', level: 2 },
              { id: 'related-topics', text: 'Related topics', level: 2 },
            ],
          },
          {
            slug: 'import-files',
            title: 'Import a file',
            contentPath: './content/data/data-foundry/import-files.mdx',
            headings: [
              { id: 'prerequisites', text: 'Prerequisites', level: 2 },
              { id: 'import-a-table', text: 'Import a table', level: 2 },
              { id: 'options', text: 'Options', level: 2 },
              { id: 'common-tasks', text: 'Common tasks', level: 2 },
              { id: 'troubleshooting', text: 'Troubleshooting', level: 2 },
              { id: 'permissions', text: 'Permissions', level: 2 },
              { id: 'related-topics', text: 'Related topics', level: 2 },
            ],
          },
          {
            slug: 'sql-console',
            title: 'Query with SQL',
            contentPath: './content/data/data-foundry/sql-console.mdx',
            headings: [
              { id: 'console-tabs', text: 'Console tabs', level: 2 },
              { id: 'writing-queries', text: 'Writing queries', level: 2 },
              { id: 'toolbar', text: 'Toolbar', level: 3 },
              { id: 'keyboard-shortcuts', text: 'Keyboard shortcuts', level: 3 },
              { id: 'previewing-tables-data-tabs', text: 'Previewing tables (data tabs)', level: 2 },
              { id: 'querying-live-connections', text: 'Querying live connections', level: 2 },
              { id: 'common-tasks', text: 'Common tasks', level: 2 },
              { id: 'troubleshooting', text: 'Troubleshooting', level: 2 },
              { id: 'permissions', text: 'Permissions', level: 2 },
              { id: 'related-topics', text: 'Related topics', level: 2 },
            ],
          },
          {
            slug: 'replication',
            title: 'Replicate tables',
            contentPath: './content/data/data-foundry/replication.mdx',
            headings: [
              { id: 'how-replication-is-organized', text: 'How replication is organized', level: 2 },
              { id: 'start-a-replication-run', text: 'Start a replication run', level: 2 },
              { id: 'reading-replication-status', text: 'Reading replication status', level: 2 },
              { id: 'when-tables-fail', text: 'When tables fail', level: 3 },
              { id: 'common-tasks', text: 'Common tasks', level: 2 },
              { id: 'troubleshooting', text: 'Troubleshooting', level: 2 },
              { id: 'permissions', text: 'Permissions', level: 2 },
              { id: 'related-topics', text: 'Related topics', level: 2 },
            ],
          },
          {
            slug: 'query-results',
            title: 'Work with query results',
            contentPath: './content/data/data-foundry/query-results.mdx',
            headings: [
              { id: 'reading-the-output-panel', text: 'Reading the Output panel', level: 2 },
              { id: 'downloading-results', text: 'Downloading results', level: 2 },
              { id: 'common-tasks', text: 'Common tasks', level: 2 },
              { id: 'troubleshooting', text: 'Troubleshooting', level: 2 },
              { id: 'permissions', text: 'Permissions', level: 2 },
              { id: 'related-topics', text: 'Related topics', level: 2 },
            ],
          },
        ],
        headings: [
          { id: 'what-you-can-do', text: 'What you can do', level: 2 },
          { id: 'a-quick-tour', text: 'A quick tour', level: 2 },
          { id: 'key-concepts', text: 'Key concepts', level: 2 },
          { id: 'getting-started', text: 'Getting started', level: 2 },
          { id: 'prerequisites', text: 'Prerequisites', level: 2 },
          { id: 'permissions', text: 'Permissions', level: 2 },
        ],
      },
    ],
  },
  {
    slug: 'loom',
    title: 'Workflow',
    collapsed: true,
    children: [
      {
        slug: 'nodes',
        title: 'Workflow nodes',
        roles: [
          'workflow-view',
          'workflow-create',
          'workflow-execute',
          'workflow-manage',
          'workflow-delete',
          'workflow-admin',
        ],
        contentPath: './content/loom/nodes/index.mdx',
        headings: [
          { id: 'how-to-read-a-node-page', text: 'How to read a node page', level: 2 },
          { id: 'what-you-see-here', text: 'What you see here', level: 2 },
          { id: 'using-a-node', text: 'Using a node', level: 2 },
        ],
      },
    ],
  },
];
